import { render, staticRenderFns } from "./SettingsForm.vue?vue&type=template&id=cd12cd34&scoped=true&lang=pug&"
import script from "./SettingsForm.vue?vue&type=script&lang=js&"
export * from "./SettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./SettingsForm.vue?vue&type=style&index=0&id=cd12cd34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd12cd34",
  null
  
)

export default component.exports